import DebitNoteDetail from "layouts/DebitNote/DebitNoteDetail";
// @mui icons
import ReceiptTwoToneIcon from "@mui/icons-material/ReceiptTwoTone";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PriceChangeTwoToneIcon from "@mui/icons-material/PriceChangeTwoTone";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GroupIcon from "@mui/icons-material/Group";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import Icon from "@mui/material/Icon";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EngineeringIcon from "@mui/icons-material/Engineering";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import GroupsIcon from "@mui/icons-material/Groups";
import ReorderIcon from "@mui/icons-material/Reorder";
import OrderItemScanQRCode from "components/ViewOrders/OrderItemScanQRCode";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import TuneIcon from "@mui/icons-material/Tune";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
//Component ---------
import Otp from "Admin/otp/otp";
import SignIn from "layouts/authentication/sign-in";
import ChangePass from "Admin/change-pass/change-pass";
import Login from "Admin/otp/res_pas/reset-pass";
import SetNewPassword from "Admin/otp/res_pas/set-new-password";

import Dashboard from "layouts/superAdminDashbord";
import Roles from "layouts/roles/roles";
import EditRoles from "layouts/roles/editRoles/editRoles";
import Permissions from "layouts/roles/permission";
import MyProfile from "layouts/profile/profile";
import EditMyProfile from "layouts/profile/editMyProfile/editMyProfile";
import StandardFeatures from "layouts/standardPlanFeature/standardPlanFeatures";
import EditStandardPlanFeature from "layouts/standardPlanFeature/editStandardPlanFeature/editStandardPlanFeature";
import SubscriptionPlan from "layouts/subscriptionPlan/subscriptionPlan";
import Users from "layouts/users/users";
import AddUser from "layouts/users/addUsers/addUsers";
import Templates from "layouts/templates/templates";
import AddTemplate from "layouts/templates/addTemplate/addTemplate";

import AddSubscriptionPlan from "layouts/subscriptionPlan/addSubscriptionPlan/addSubscription";
import AddPlanFeatures from "layouts/subscriptionPlan/addPlanFeature/addPlanFeature";
import calculateRoleRights, { screenRight } from "utils/roleRightPermissions";
import Parameters from "layouts/parameter/parameters";
import EditParameter from "layouts/parameter/editParameter/editParamter";
import AddParameterLsit from "layouts/parameter/editParameter/addParameterList/addParameterList";
import Customers from "layouts/Customers/Customer";
import AddNewCustomer from "layouts/Customers/addNewCustomer/addNewCustomer";
import Contacts from "layouts/Contacts/contacts";
import AddContact from "layouts/Contacts/addContact";
import ContactDetails from "layouts/Contacts/contactDetails";
import EditEmployee from "layouts/Employees/EditEmployee/EditEmployee";
import AddDocument from "layouts/Employees/AddDocument";
import EditVehicle from "layouts/Vehicles/EditVehicle";
import AddVehicleDocument from "layouts/Vehicles/AddVehicleDocument";
import AddNewWarehouse from "layouts/Warehouse/AddWarehouse/AddWarehouse";
import EditBATGroup from "layouts/BATGroup/EditBATGroup/EditBATGroup";
import AddBATVehicle from "layouts/BATGroup/EditBATGroup/AddBATVehicle";
import AddNewDeliveryTime from "layouts/DelieveryTime/AddDeliveryTime/AddDeliveryTime";
import ParameterSetting from "layouts/parameterSettings/parameterSettings";
import AddParameterSettings from "layouts/parameterSettings/AddParameterSettings/AddParameterSettings";
import AddCargoWeightCharges from "layouts/shipmentCharges/addCargoWeight";
import AddCargoPickupCharges from "layouts/shipmentCharges/addCargoPickup";
import Clients from "layouts/clients/clients";
import ClientInfo from "layouts/clients/client-info";
import ViewOrders from "components/ViewOrders/ViewOrder";
import AssignDriver from "components/ViewOrders/AssignDriver";
import AddNewChecklist from "layouts/checklist/AddNewChecklists/AddNewChecklist";
import NewChecklist from "layouts/checklist/NewChecklist";
import EditOrder from "layouts/Orders/editOrder";
import WarehouseDashboard from "layouts/WarehouseDashboard/WarehouseDashboard";
import ViewDetailsWarehouse from "layouts/WarehouseDashboard/viewDetailsWarehouse";
import ViewSummary from "layouts/WarehouseDashboard/viewSummary";
import MakePayment from "layouts/makePayment/makeOrderPayment";
import BillingScreen from "layouts/BillingScreen/BillingScreen";
import ClientReport from "layouts/report/ClientReport";
import PaymentReport from "layouts/report/PaymentReport";
import AddBusinessUserChecklist from "layouts/checklist/AddNewChecklists/AddBusinessUserChecklist";
import LoadPlanVehicle from "layouts/LoadVehicles/loadVehicles";
import AddLoadPlanVehicle from "layouts/LoadVehicles/AddLoadVehicles/addLoadVehicles";
import RecieveOrder from "layouts/recieveOrder/recieveOrder";
import SignUpCover from "layouts/customerSignUp/customerSignUp";
import CustomerLogin from "layouts/customerSignUp/customerLogin";
import CustomerProfile from "layouts/profile/customerProfile";
import EditCustomeerProfile from "layouts/profile/editMyProfile/editCustomerProfile";
import CustomerResetPass from "Admin/otp/res_pas/customerResetPass";
import CustomerOrder from "layouts/CustomerOrders/customerOrder";
import NewOrders from "layouts/Orders/newAddOrder";
import AddAddressHistory from "layouts/addressHistory/addressHistory";
import {
  Assessment,
  Receipt,
  ReceiptLong,
  Settings,
} from "@mui/icons-material";
import AddCustomerOrder from "layouts/CustomerOrders/addCustomerOrder";
import BusinessUserDashboard from "layouts/businessUserDashboard";
import BuSignUp from "layouts/authentication/sign-up/buSiginUp";
import VerifyEmail from "layouts/authentication/sign-up/VerifyEmail";
import Cover from "layouts/authentication/sign-up";

import Quotations from "layouts/Quotation/Quotation";
import AddQuotation from "layouts/Quotation/AddQuotation";
import CustomerViewQuotation from "layouts/Quotation/CustomerQuotationReview";
import ViewQuotation from "layouts/Quotation/ViewQuotation";
// Integration Routes by Karan
import CategoryIcon from "@mui/icons-material/Category";
import SettingsPage from "layouts/Settings/Settings";
import ItemCategory from "layouts/ItemCategory/ItemCatogories";
import AddItemCategory from "layouts/ItemCategory/AddItemCategory";
import Items from "layouts/Items/Items";
import Expenses from "layouts/Expenses/Expenses";
import AddExpenses from "layouts/Expenses/AddExpenses";
import ExpenseDetails from "layouts/Expenses/ExpenseDetails";
import InvoiceReminderTemplate from "layouts/invoiceReminder/invoiceReminderTemplate";
import AddInvoiceReminderTemplate from "layouts/invoiceReminder/addInvoiceReminderTemplate/addInvoiceReminderTemplate";
import Invoices from "layouts/Invoices/Invoices";
import AddInvoice from "layouts/Invoices/AddInvoice";
import InvoiceCreationGate from "layouts/Invoices/InvoiceCreationGate";
import ViewInvoices from "layouts/Invoices/ViewInvoices";
import InvoiceHistory from "layouts/Invoices/InvoiceHistory";
import PreviewInvoices from "layouts/Invoices/PreviewDownloadInvoices";
import PreviewQuotation from "layouts/Quotation/PreviewDownloadQuotation";
import InvoicesPayment from "layouts/Invoices/InvoicesPayment";
import Debts from "layouts/Invoices/Debts";
import ViewDebts from "layouts/Invoices/ViewDebts";
import RCTI from "layouts/RCTI/RCTI";
import RctiAgreements from "layouts/RCTI/RctiAgreements";
import SupplierRCTI from "layouts/RCTI/SupplierRCTI";
import PublicRctiAgreement from "layouts/RCTI/PublicRctiAgreement";
import AddRCTI from "layouts/RCTI/AddRCTI";
import ViewRCTI from "layouts/RCTI/ViewRCTI";
import QuotationReport from "layouts/report/QuotationReport";
import InvoiceReport from "layouts/report/InvoiceReport";
import RctiReport from "layouts/report/RctiReport";
//Integration Routes by Bharat
import ContactReport from "layouts/report/ContactReport";
import ExpensesReport from "layouts/report/ExpensesReport";
import InvoiceReminderLogs from "layouts/report/InvoiceReminderLogs";
import CustomerViewInvoice from "layouts/Invoices/CustomerViewInvoice";
import SettingsIcon from "@mui/icons-material/Settings";
import AgedReceivables from "layouts/report/AgedReceivablesSummary";
import AgedPayables from "layouts/report/AgedPayablesSummary";
import UploadLegalDocuments from "layouts/UploadLegalDocuments/UploadLegalDocuments";
import InvoicePdfFormat from "layouts/InvoicePdfFormat/invoicePdfFormat";
import AddInvoicePdfFormat from "layouts/InvoicePdfFormat/addInvoicePdfFormat";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GridViewIcon from "@mui/icons-material/GridView";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import DescriptionIcon from "@mui/icons-material/Description";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PaymentsIcon from "@mui/icons-material/Payments";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import Blank from "layouts/Blank/blank";
import ActivityStatement from "layouts/Contacts/activityStatement";
import PreviewRCTI from "layouts/RCTI/PreviewDownloadRCTI";
import ViewCreditUsed from "layouts/BillingScreen/ViewCreditUsage";
import ItemsReport from "layouts/report/ItemReport";
import HelpScreen from "layouts/Help/helpScreen";
import ReportForItem from "layouts/report/ReportItems";
import ContactViewAgree from "layouts/Contacts/contactViewAgreement";
import CreditSearch from "layouts/CreditNote/AdjustmentCreditRegister";
import AddCreditNote from "layouts/CreditNote/AdjustmentCreditEditor";
import ViewCredits from "layouts/CreditNote/AdjustmentCreditDetail";
import CustomerViewCred from "layouts/CreditNote/PreviewDownloadCredit";
import DebitNote from "layouts/DebitNote/DebitNote";
import DebitNoteEditor from "layouts/DebitNote/DebitNoteEditor";

calculateRoleRights();

export var routes = [
  {
    type: "",
    name: "Settings",
    key: "settings",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <SettingsIcon />
      </Icon>
    ),
    route: "/settings",
    component: <SettingsPage />,
    guarded: true,
    permission: screenRight.mysettings,
  },
  {
    type: "",
    name: "Change password",
    key: "settings-change-password",
    user: "business",
    route: "/settings/change-password",
    component: <SettingsPage />,
    guarded: true,
    permission: screenRight.mysettings,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: (
      <Icon fontSize="small" style={{ marginTop: "5px" }}>
        dashboard
      </Icon>
    ),
    route: "/dashboard",
    user: "business",
    guarded: true,
    component: <BusinessUserDashboard />,
    permission: screenRight.buDashboard,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard-su",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard-su",
    guarded: true,
    user: "admin",
    component: <Dashboard />,
    permission: screenRight.saDashboard,
  },
  {
    type: "collapse",
    name: "Business Users",
    key: "clients",
    icon: (
      <Icon fontSize="small">
        <GroupsIcon />
      </Icon>
    ),
    route: "/clients",
    user: "admin",
    component: <Clients />,
    guarded: true,
    permission: screenRight.businessUsers,
  },

  {
    type: "",
    name: "Clients",
    key: "clients",
    icon: (
      <Icon fontSize="small">
        <VerifiedUserIcon />
      </Icon>
    ),
    route: "/clients/client_info/:id",
    component: <ClientInfo />,
    permission: screenRight.businessUsers,
  },

  {
    type: "collapse",
    name: "Standard Features",
    key: "standardFeatures",
    icon: (
      <Icon fontSize="small">
        <FormatListBulletedIcon />
      </Icon>
    ),
    route: "/standardFeatures",
    user: "admin",
    component: <StandardFeatures />,
    permission: screenRight.standardPlanFeatures,
  },
  {
    type: "",
    name: "",
    key: "AddStandardFeatures",
    icon: (
      <Icon fontSize="small">
        <FormatListBulletedIcon />
      </Icon>
    ),
    route: "/standardFeatures/edit/:id",
    component: <EditStandardPlanFeature />,
    permission: screenRight.standardPlanFeatures,
  },
  {
    type: "",
    name: "",
    key: "AddStandardFeatures",
    icon: (
      <Icon fontSize="small">
        <FormatListBulletedIcon />
      </Icon>
    ),
    route: "/standardFeatures/edit/",
    component: <EditStandardPlanFeature />,
    permission: screenRight.standardPlanFeatures,
  },
  {
    type: "collapse",
    name: "Subscription Plans",
    key: "subscriptionPlan",
    icon: (
      <Icon fontSize="small">
        <AccountBalanceWalletIcon />
      </Icon>
    ),
    route: "/subscriptionPlan",
    component: <SubscriptionPlan />,
    user: "admin",
    permission: screenRight.subscriptionPlans,
  },
  {
    type: "",
    name: "Subscription Plan",
    key: "subscriptionPlan",
    icon: (
      <Icon fontSize="small">
        <AccountBalanceWalletIcon />
      </Icon>
    ),
    route: "/subscriptionPlan/new",
    component: <AddSubscriptionPlan />,
    permission: screenRight.subscriptionPlans,
  },
  {
    type: "",
    name: "Subscription Plan",
    key: "subscriptionPlan",
    icon: (
      <Icon fontSize="small">
        <AccountBalanceWalletIcon />
      </Icon>
    ),
    route: "/subscriptionPlan/edit/:id",
    component: <AddSubscriptionPlan />,
    permission: screenRight.subscriptionPlans,
  },
  {
    type: "",
    name: "Subscription Plan",
    key: "subscriptionPlan",
    icon: (
      <Icon fontSize="small">
        <AccountBalanceWalletIcon />
      </Icon>
    ),
    route: "/subscriptionPlan/addPlanFeatures",
    component: <AddPlanFeatures />,
    permission: screenRight.subscriptionPlans,
  },
  {
    type: "",
    name: "Subscription Plan",
    key: "subscriptionPlan",
    icon: (
      <Icon fontSize="small">
        <AccountBalanceWalletIcon />
      </Icon>
    ),
    route: "/subscriptionPlan/editPlanFeatures/:id",
    component: <AddPlanFeatures />,
    permission: screenRight.subscriptionPlans,
  },

  {
    type: "collapse",
    name: "Roles",
    key: "roles",
    icon: <Icon fontSize="small">verifiedUserIcon </Icon>,
    route: "/roles",
    user: "admin",
    component: <Roles />,

    permission: screenRight.roles,
  },
  {
    type: "",
    name: "Add Roles",
    key: "Roles",
    icon: <Icon fontSize="small">EditRoles</Icon>,
    route: "/roles/new",
    component: <EditRoles />,
    permission: screenRight.roles,
  },

  {
    type: "",
    name: "Edit Roles",
    key: "roles",
    icon: <Icon fontSize="small">Edit Roles</Icon>,
    route: "/roles/edit/:id",
    component: <EditRoles />,
    title: "Edit Roles",
    permission: screenRight.roles,
  },
  {
    type: "",
    name: "Permission",
    key: "roles",
    icon: <Icon fontSize="small">Permission</Icon>,
    route: "/roles/:id",
    component: <Permissions />,
    permission: screenRight.roles,
  },

  {
    type: "collapse",
    name: "Users",
    key: "users",
    user: "admin",
    icon: <Icon fontSize="small">groupIcon </Icon>,
    route: "/users",
    component: <Users />,
    permission: screenRight.users,
  },
  {
    type: "",
    name: "Add Users",
    key: "users",
    icon: <Icon fontSize="small">Add users</Icon>,
    route: "/users/new",
    component: <AddUser />,
    permission: screenRight.users,
  },
  {
    type: "",
    name: "Edit User",
    key: "users",
    icon: <Icon fontSize="small">Edit User</Icon>,
    route: "/users/edit/:id",
    component: <AddUser />,
    title: "Edit User",
    permission: screenRight.users,
  },

  {
    type: "collapse",
    name: "Templates",
    key: "templates",
    user: "admin",
    icon: (
      <Icon fontSize="small">
        <ViewQuiltIcon />
      </Icon>
    ),
    route: "/templates",
    component: <Templates />,
    permission: screenRight.templates,
  },
  {
    type: "",
    name: "Add Template",
    key: "templates",
    icon: <Icon fontSize="small">Add Template</Icon>,
    route: "/templates/new",
    component: <AddTemplate />,
    permission: screenRight.templates,
  },
  {
    type: "",
    name: "Edit Template",
    key: "templates",
    icon: <Icon fontSize="small">Edit Template</Icon>,
    route: "/templates/edit/:id",
    component: <AddTemplate />,
    permission: screenRight.templates,
  },
  {
    type: "",
    name: "Edit My Profile",
    key: "editProfileNew",
    icon: <Icon fontSize="small">Edit My Profile</Icon>,
    route: "/editprofile",
    component: <EditMyProfile />,
    permission: screenRight.profile,
  },
  {
    type: "",
    name: "Edit My Profile",
    key: "editCusProfile",
    icon: <Icon fontSize="small">Edit My Profile</Icon>,
    route: "/editCusProfile",
    component: <EditCustomeerProfile />,
    permission: screenRight.profile,
  },

  {
    type: "collapse",
    name: "Parameter Settings",
    key: "parametersetting",
    user: "admin",
    icon: (
      <Icon fontSize="small">
        <Settings />
      </Icon>
    ),
    route: "/parametersetting",
    component: <ParameterSetting />,
    permission: screenRight.parameterSettings,
  },

  {
    type: "",
    name: "Parameter Settings",
    key: "parametersetting",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/parametersetting/addNew",
    component: <AddParameterSettings />,
    permission: screenRight.parameterSettings,
  },
  {
    type: "",
    name: "Parameter Settings",
    key: "parametersetting",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/parametersetting/edit/:id",
    component: <AddParameterSettings />,
    permission: screenRight.parameterSettings,
  },

  {
    type: "collapse",
    name: "Parameter Lists",
    key: "parameter",
    user: "admin",
    icon: (
      <Icon fontSize="small">
        <ReceiptLong />
      </Icon>
    ),
    route: "/parameter",
    component: <Parameters />,
    permission: screenRight.parameter,
  },
  {
    type: "",
    name: "Parameter",
    key: "parameter",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/parameter/addParameter",
    component: <EditParameter />,
    permission: screenRight.parameter,
  },
  {
    type: "",
    name: "Parameter",
    key: "parameter",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/parameter/editParameter/:id",
    component: <EditParameter />,
    permission: screenRight.parameter,
  },
  {
    type: "",
    name: "addParameterList",
    key: "parameter",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/parameter/addParameterList/:parameterId",
    component: <AddParameterLsit />,
    permission: screenRight.parameter,
  },
  {
    type: "",
    name: "editParameterList",
    key: "parameter",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/parameter/editParameterList/:id",
    component: <AddParameterLsit />,
    permission: screenRight.parameter,
  },
  {
    type: "",
    name: "",
    key: "warehouse",
    icon: (
      <Icon fontSize="small">
        <WarehouseIcon />
      </Icon>
    ),
    route: "/warehouse/addWarehouse",
    component: <AddNewWarehouse />,
    permission: screenRight.warehouse,
  },
  {
    type: "",
    name: "",
    key: "warehouse",
    icon: (
      <Icon fontSize="small">
        <WarehouseIcon />
      </Icon>
    ),
    route: "/warehouse/editWarehouse/:id",
    component: <AddNewWarehouse />,
    permission: screenRight.warehouse,
  },
  {
    type: "",
    name: "",
    key: "employees",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/employees/addEmployee",
    component: <EditEmployee />,
    permission: screenRight.employees,
  },
  {
    type: "",
    name: "",
    key: "employees",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/employees/editEmployee/:id",
    component: <EditEmployee />,
    permission: screenRight.employees,
  },
  {
    type: "",
    name: "",
    key: "employees",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/employees/editEmployee/:employeeID",
    component: <EditEmployee />,
    permission: screenRight.employees,
  },
  {
    type: "",
    name: "",
    key: "employees",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/employees/addDocument/:employeeID",
    component: <AddDocument />,
    permission: screenRight.employees,
  },
  {
    type: "",
    name: "",
    key: "employees",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/employees/editDocument/:id",
    component: <AddDocument />,
    permission: screenRight.employees,
  },
  {
    type: "",
    name: "",
    key: "vehicles",
    icon: (
      <Icon fontSize="small">
        <LocalShippingIcon />
      </Icon>
    ),
    route: "/vehicles/addNewVehicle",
    component: <EditVehicle />,
    permission: screenRight.vehicles,
  },
  {
    type: "",
    name: "",
    key: "vehicles",
    icon: (
      <Icon fontSize="small">
        <LocalShippingIcon />
      </Icon>
    ),
    route: "/vehicles/editVehicle/:id",
    component: <EditVehicle />,
    permission: screenRight.vehicles,
  },
  {
    type: "",
    name: "",
    key: "vehicles",
    icon: (
      <Icon fontSize="small">
        <LocalShippingIcon />
      </Icon>
    ),
    route: "/vehicles/editVehicle/:vehicleID",
    component: <EditVehicle />,
    permission: screenRight.vehicles,
  },
  {
    type: "",
    name: "",
    key: "vehicles",
    icon: (
      <Icon fontSize="small">
        <LocalShippingIcon />
      </Icon>
    ),
    route: "/vehicles/addVehicleDocument/:vehicleID",
    component: <AddVehicleDocument />,
    permission: screenRight.vehicles,
  },
  {
    type: "",
    name: "",
    key: "vehicles",
    icon: (
      <Icon fontSize="small">
        <LocalShippingIcon />
      </Icon>
    ),
    route: "/vehicles/editVehicleDocument/:id",
    component: <AddVehicleDocument />,
    permission: screenRight.vehicles,
  },

  {
    type: "",
    name: "BAT Group",
    key: "batGroup",
    icon: (
      <Icon fontSize="small">
        <ContentPasteIcon />
      </Icon>
    ),
    route: "/batGroup/addNewBATGroup",
    component: <EditBATGroup />,
    permission: screenRight.batGroup,
  },
  {
    type: "",
    name: "BAT Group",
    key: "batGroup",
    icon: (
      <Icon fontSize="small">
        <ContentPasteIcon />
      </Icon>
    ),
    route: "/batGroup/editBATGroup/:id",
    component: <EditBATGroup />,
    permission: screenRight.batGroup,
  },
  {
    type: "",
    name: "",
    key: "batGroup",
    icon: (
      <Icon fontSize="small">
        <ContentPasteIcon />
      </Icon>
    ),
    route: "/batGroup/editBATGroup/addBATVehicle/:batGroupID",
    component: <AddBATVehicle />,
    permission: screenRight.batGroup,
  },
  {
    type: "",
    name: "",
    key: "batGroup",
    icon: (
      <Icon fontSize="small">
        <ContentPasteIcon />
      </Icon>
    ),
    route: "/batGroup/editBATGroup/editBATVehicle/edit/:id",
    component: <AddBATVehicle />,
    permission: screenRight.batGroup,
  },

  //
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/customers",
    component: <Customers />,
    permission: screenRight.customers,
  },
  {
    type: "",
    name: "",
    key: "customers",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/customers/addNewCustomer",
    component: <AddNewCustomer />,
    permission: screenRight.customers,
  },
  {
    type: "",
    name: "",
    key: "customers",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/customers/editCustomer/edit/:id",
    component: <AddNewCustomer />,
    permission: screenRight.customers,
  },
  {
    type: "",
    name: "",
    key: "deliveryTime",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/deliveryTime/new",
    component: <AddNewDeliveryTime />,
    permission: screenRight.deliveryTime,
  },
  {
    type: "",
    name: "",
    key: "deliveryTime",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "deliveryTime/edit/:id",
    component: <AddNewDeliveryTime />,
    permission: screenRight.deliveryTime,
  },
  {
    type: "",
    name: "",
    key: "shipmentCharges",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/shipmentCharges/weightCharges/new",
    component: <AddCargoWeightCharges />,
    permission: screenRight.shipmentCharges,
  },
  {
    type: "",
    name: "",
    key: "shipmentCharges",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/shipmentCharges/weightCharges/edit/:id",
    component: <AddCargoWeightCharges />,
    permission: screenRight.shipmentCharges,
  },

  {
    type: "",
    name: "",
    key: "shipment",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/shipmentCharges/pickupCharges/new",
    component: <AddCargoPickupCharges />,
    permission: screenRight.shipmentCharges,
  },
  {
    type: "",
    name: "",
    key: "shipment",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/shipmentCharges/pickupCharges/edit/:id",
    component: <AddCargoPickupCharges />,
    permission: screenRight.shipmentCharges,
  },
  {
    type: "",
    name: "Subscriptions",
    key: "subscriptions",
    icon: (
      <Icon fontSize="small">
        <ReceiptLongIcon />
      </Icon>
    ),
    route: "/subscriptions",
    component: <BillingScreen />,
    permission: screenRight.billing,
  },

  {
    type: "",
    name: "Subscriptions",
    key: "subscriptions",
    icon: (
      <Icon fontSize="small">
        <ReceiptLongIcon />
      </Icon>
    ),
    route: "/subscriptions/viewCredits",
    component: <ViewCreditUsed />,
    permission: screenRight.billing,
  },

  {
    type: "",
    name: "Add Orders",
    key: "orders",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/orders/addCustOrder/new",
    component: <AddCustomerOrder />,
    permission: screenRight.customerOrders,
  },

  {
    type: "",
    name: "recieveOrder",
    key: "recieveOrder",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/recieveOder/:id",
    component: <RecieveOrder />,
    permission: screenRight.customerOrders,
  },

  {
    type: "",
    name: "View Orders",
    key: "orders",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/orders/vieworders/:id",
    component: <ViewOrders />,
    permission: screenRight.customerOrders,
  },
  {
    type: "",
    name: "View Orders",
    key: "orders",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/orders/assignDriver/:id",
    component: <AssignDriver />,
    permission: screenRight.customerOrders,
  },

  {
    type: "",
    name: "Add Orders",
    key: "orders",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/orders/new",
    component: <NewOrders />,
    permission: screenRight.orders,
  },
  {
    type: "",
    name: "Add Orders",
    key: "orders",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/orders/editOrder/:id",
    component: <NewOrders />,
    permission: screenRight.orders,
  },

  {
    type: "",
    name: "Add Address",
    key: "Add Address",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/addAddress/:customerID",
    component: <AddAddressHistory />,
    permission: screenRight.orders,
  },
  {
    type: "",
    name: "Edit Address",
    key: "Edit Address",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/editAddress/:id",
    component: <AddAddressHistory />,
    permission: screenRight.orders,
  },
  {
    type: "",
    name: "Add Orders",
    key: "Addorders",
    icon: (
      <Icon fontSize="small">
        <ReorderIcon />
      </Icon>
    ),
    route: "/editOrders/:id",
    component: <EditOrder />,
    permission: screenRight.orders,
  },
  {
    type: "collapse",
    name: "Driver Checklists",
    key: "newChecklist",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/newChecklist",
    component: <NewChecklist />,
    permission: screenRight.driverChecklists,
  },

  {
    type: "",
    name: "",
    key: "addchecklist",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/addNewChecklist",
    component: <AddNewChecklist />,
    permission: screenRight.driverChecklists,
  },
  {
    type: "",
    name: "",
    key: "checklist",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/editChecklist/edit/:id",
    component: <AddNewChecklist />,
    permission: screenRight.driverChecklists,
  },
  {
    type: "",
    name: "",
    key: "EditBusinessUserChecklist",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/editBusinessUserChecklist/edit/:id",
    component: <AddBusinessUserChecklist />,
    permission: screenRight.driverChecklists,
  },

  {
    type: "",
    name: "",
    key: "addBusinessUserChecklist",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/addBusinessUserChecklist",
    component: <AddBusinessUserChecklist />,
    permission: screenRight.driverChecklists,
  },
  {
    type: "collapse",
    name: "Warehouse Dashboard",
    key: "warehouseDashboard",
    icon: (
      <Icon fontSize="small">
        <WarehouseIcon />
      </Icon>
    ),
    route: "/warehouseDashboard",
    component: <WarehouseDashboard />,
    permission: screenRight.warehouseDashboard,
  },
  {
    type: "",
    name: "",
    key: "viewWarehouseDashboard",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/viewDetailsWarehouse/:id",
    component: <ViewDetailsWarehouse />,
    permission: screenRight.warehouseDashboard,
  },

  {
    type: "",
    name: "",
    key: "viewSummary",
    icon: (
      <Icon fontSize="small">
        <CheckCircleOutlineIcon />
      </Icon>
    ),
    route: "/viewSummary/:slotNo/:id",
    component: <ViewSummary />,
    permission: screenRight.warehouseDashboard,
  },

  {
    type: "collapse",
    name: "Load Plan Vehicles ",
    key: "loadVehicles",
    icon: (
      <Icon fontSize="small">
        <LocalShippingIcon />
      </Icon>
    ),
    route: "/loadVehicles",
    component: <LoadPlanVehicle />,
    permission: screenRight.loadPlanVehicle,
  },
  {
    type: "",
    name: "",
    key: "loadVehicles",
    icon: (
      <Icon fontSize="small">
        <LocalShippingIcon />
      </Icon>
    ),
    route: "/loadVehicles/addLoadVehicles",
    component: <AddLoadPlanVehicle />,
    permission: screenRight.loadPlanVehicle,
  },
  {
    type: "",
    name: "",
    key: "loadVehicles",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/loadVehicles/editLoadVehicles/edit/:id",
    component: <AddLoadPlanVehicle />,
    permission: screenRight.loadPlanVehicle,
  },

  {
    type: "option",
    name: "Report",
    key: "",
    user: "admin",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    // route: "/paymentReport",
    // component: <PaymentReport />,
    option: [
      {
        name: "Clients Report",
        route: "/clientReport",
        permission: screenRight.clientsReport,
        key: "clientReport",
        icon: (
          <Icon fontSize="small">
            <Receipt />
          </Icon>
        ),
      },
      // { name: 'Payments Report', route: '/paymentReport', permission: screenRight.paymentReport, key: "paymentReport", icon: <Icon fontSize="small"><Receipt /></Icon> },
      // { name: 'Subscription Invoices Report', route: '/invoiceReport', permission: screenRight.invoiceReport, key: "invoiceReport", icon: <Icon fontSize="small">menuBookRoundedIcon</Icon> }
    ],
    permission: screenRight.clientsReport,
  },

  {
    type: "",
    name: "client Report ",
    key: "clientReport",
    icon: (
      <Icon fontSize="small">
        <Assessment />
      </Icon>
    ),
    route: "/clientReport",
    component: <ClientReport />,
    permission: screenRight.clientsReport,
  },
  {
    type: "",
    name: "Payment Report",
    key: "paymentReport",
    // icon: <Icon fontSize="small"><Receipt /></Icon>,
    route: "/paymentReport",
    component: <PaymentReport />,
    permission: screenRight.clientsReport,
  },
  {
    type: "",
    name: "Invoice Report",
    key: "invoiceReport",
    icon: <Icon fontSize="small">menuBookRoundedIcon</Icon>,
    route: "/invoiceReport",
    component: <InvoiceReport />,
    permission: screenRight.clientsReport,
  },

  {
    type: "",
    name: "My Profile",
    key: "MyProfile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/MyProfile",
    component: <MyProfile />,
    permission: screenRight.myProfile,
  },

  {
    type: "",
    name: "b",
    key: "b",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/b",
    component: <Blank />,
    permission: screenRight.myProfile,
  },

  {
    type: "",
    name: "My Profile",
    key: "MyProfile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/CusProfile",
    component: <CustomerProfile />,
    permission: screenRight.myProfile,
  },

  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },

  {
    type: "",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/login",
    component: <SignIn />,
    guarded: false,
    permission: screenRight.myProfile,
  },
  {
    type: "",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/customerLogin",
    component: <CustomerLogin />,
    guarded: false,
    permission: screenRight.myProfile,
  },

  {
    type: "",
    name: "Sign Up Cover",
    key: "Sign Up Cover",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/customer/sign-up",
    component: <SignUpCover />,
    guarded: false,
    permission: screenRight.myProfile,
  },

  {
    type: "",
    name: "Make Payment",
    key: "make-payment",
    icon: <Icon fontSize="small">Payment</Icon>,
    route: "/makePayment/:id",
    component: <MakePayment />,
    guarded: false,
    permission: screenRight.makePayment,
  },

  {
    type: "",
    name: "Verify Email",
    key: "verify-email",
    icon: <Icon fontSize="small">mark_email_read</Icon>,
    route: "/verify-email",
    component: <VerifyEmail />,
    guarded: false,
    permission: screenRight.myProfile,
  },
  {
    type: "",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/wizard/:id",
    component: <Cover />,
    guarded: false,
    permission: screenRight.myProfile,
  },

  {
    type: "",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <BuSignUp />,
    guarded: false,
    permission: screenRight.myProfile,
  },
  {
    type: "",
    name: "OTP",
    key: "otp",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/otp",
    component: <Otp />,
    guarded: false,
    permission: screenRight.myProfile,
  },
  {
    type: "",
    name: "Set New Password",
    key: "set-new-password",
    icon: <Icon fontSize="small">lock_reset</Icon>,
    route: "/set-new-password",
    component: <SetNewPassword />,
    guarded: false,
    permission: screenRight.myProfile,
  },
  {
    type: "",
    name: "OTP",
    key: "otp",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/reset-pass",
    component: <Login />,
    guarded: false,
    permission: screenRight.myProfile,
  },
  {
    type: "",
    name: "OTP",
    key: "otp",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/customer-reset-pass",
    component: <CustomerResetPass />,
    guarded: false,
    permission: screenRight.myProfile,
  },

  {
    type: "",
    name: "",
    key: "",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/change",
    component: <ChangePass />,
    guarded: false,
    permission: screenRight.myProfile,
  },
  {
    type: "",
    name: "",
    key: "",
    // icon: <Icon fontSize="small">assignment</Icon>,
    route: "/Order_Item/:id",
    component: <OrderItemScanQRCode />,
    guarded: false,
    permission: 1,
  },

  //Quotation
  {
    type: "collapse",
    name: "Quotations",
    key: "quotations",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/quotations",
    component: <Quotations />,
    guarded: true,
    permission: screenRight.quotations,
  },
  {
    type: "",
    name: "",
    key: "quotations",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/quotations/add",
    component: <AddQuotation />,
    guarded: true,
    permission: screenRight.quotations,
  },
  {
    type: "",
    name: "",
    key: "quotations",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/quotations/edit/:id",
    component: <AddQuotation />,
    guarded: true,
    permission: screenRight.quotations,
  },
  {
    type: "",
    name: "",
    key: "quotations",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/quotations/view/:id",
    component: <ViewQuotation />,
    guarded: true,
    permission: screenRight.quotations,
  },
  {
    type: "",
    name: "",
    key: "quotations",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/quotations/quotation/:quotationNumber/:id",
    component: <PreviewQuotation />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "quotation",
    key: "quotation",
    route: "/quotation/:quotationNumber/:id",
    component: <CustomerViewQuotation />,
    guarded: false,
    permission: "Full Access",
  },
  {
    type: "",
    name: "quotation",
    key: "quotation",
    route: "/contact/:contactType/:id",
    component: <ContactViewAgree />,
    guarded: false,
    permission: "Full Access",
  },
  {
    type: "collapse",
    name: "Invoices",
    key: "invoices",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <DescriptionIcon />
      </Icon>
    ),
    route: "/invoices",
    component: <Invoices />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "",
    key: "invoices",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/invoices/add",
    component: <InvoiceCreationGate />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "",
    key: "invoices",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/invoices/edit/:id",
    component: <AddInvoice />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "",
    key: "invoices",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/invoices/view/:id",
    component: <ViewInvoices />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "",
    key: "invoices",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/invoices/invoice/:invoiceNumber/:id",
    component: <PreviewInvoices />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "",
    key: "invoices",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/invoices/payment/:id",
    component: <InvoicesPayment />,
    guarded: true,
    permission: screenRight.invoices,
  },
  //Independent Page
  {
    type: "",
    name: "invoice",
    key: "invoice",
    route: "/invoice/:invoiceNumber/:id",
    component: <CustomerViewInvoice />,
    guarded: false,
    permission: "Full Access",
  },
  //Activity statement of Invoice
  {
    type: "",
    name: "Activity Statement",
    key: "activityStatement",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/invoices/activityStatement/:id",
    component: <ActivityStatement />,
    permission: "",
  },

  {
    type: "collapse",
    name: "RCTI Agreements",
    key: "rcti-agreements",
    user: "business",
    icon: <ReceiptTwoToneIcon />,
    route: "/rcti-agreements",
    component: <RctiAgreements />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "rcti-agreement-new",
    route: "/rcti-agreements/new",
    component: <RctiAgreements />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "rcti-agreement-detail",
    route: "/rcti-agreements/:id",
    component: <RctiAgreements />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "supplier-rcti-public",
    route: "/rcti-received/:id",
    component: <SupplierRCTI />,
    guarded: false,
    permission: "",
  },
  {
    type: "",
    name: "",
    key: "rcti-agreement-public",
    route: "/rcti-agreement/:mode/:id",
    component: <PublicRctiAgreement />,
    guarded: false,
    permission: "",
  },
  //RCTI
  {
    type: "collapse",
    name: "RCTI",
    key: "rcti",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/rcti",
    component: <RCTI />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "rcti",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/rcti/add",
    component: <AddRCTI />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "rcti",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/rcti/edit/:id",
    component: <AddRCTI />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "rcti-version",
    route: "/rcti/view/:id/versions/:version",
    component: <PreviewRCTI />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "rcti",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/rcti/view/:id",
    component: <ViewRCTI />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "",
    name: "",
    key: "rcti",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/rctis/rcti/:rctiNumber/:id",
    component: <PreviewRCTI />,
    guarded: true,
    permission: screenRight.RCTI,
  },
  {
    type: "collapse",
    name: "Credit Note",
    key: "credit",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <DescriptionIcon />
      </Icon>
    ),
    route: "/creditNote",
    component: <CreditSearch />,
    guarded: true,
    permission: screenRight.credit,
  },
  {
    type: "collapse",
    name: "Debit Note",
    key: "debitNote",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <DescriptionIcon />
      </Icon>
    ),
    route: "/debitNote",
    component: <DebitNote />,
    guarded: true,
    permission: screenRight.debit,
  },
  {
    type: "",
    name: "New Debit Note",
    key: "debitNoteAdd",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <DescriptionIcon />
      </Icon>
    ),
    route: "/debitNote/add",
    component: <DebitNoteEditor />,
    guarded: true,
    permission: screenRight.debit,
  },
  {
    key: "debitNoteEdit",
    route: "/debitNote/edit/:id",
    component: <DebitNoteEditor />,
    guarded: true,
    permission: screenRight.debit,
  },
  {
    key: "debitNoteView",
    route: "/debitNote/view/:id",
    component: <DebitNoteDetail />,
    guarded: true,
    permission: screenRight.debit,
  },
  {
    type: "",
    name: "",
    key: "credit",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/creditNote/add",
    component: <AddCreditNote />,
    guarded: true,
    permission: screenRight.credit,
  },
  {
    type: "",
    name: "",
    key: "credit",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/creditNote/edit/:id",
    component: <AddCreditNote />,
    guarded: true,
    permission: screenRight.credit,
  },
  {
    type: "",
    name: "",
    key: "credit",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/creditNote/view/:id",
    component: <ViewCredits />,
    guarded: true,
    permission: screenRight.credit,
  },
  {
    type: "",
    name: "",
    key: "credit",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/creditNote/credit/:creditNumber/:id",
    component: <CustomerViewCred />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "Activity Statement",
    key: "activityStatement",
    icon: (
      <Icon fontSize="small">
        <PendingActionsIcon />
      </Icon>
    ),
    route: "/credit/activityStatement/:id",
    component: <ActivityStatement />,
    permission: "",
  },
  //Expenses
  {
    type: "collapse",
    name: "Expenses",
    key: "expenses",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <PriceChangeTwoToneIcon />
      </Icon>
    ),
    route: "/expenses",
    component: <Expenses />,
    guarded: true,
    permission: screenRight.expenses,
  },
  {
    type: "",
    name: "",
    key: "",
    icon: (
      <Icon fontSize="small">
        <PriceChangeTwoToneIcon />
      </Icon>
    ),
    route: "/expenses/addExpenses",
    component: <AddExpenses />,
    guarded: true,
    permission: screenRight.expenses,
  },
  {
    type: "",
    name: "",
    key: "",
    icon: (
      <Icon fontSize="small">
        <PriceChangeTwoToneIcon />
      </Icon>
    ),
    route: "/expenses/editExpenses/:id",
    component: <AddExpenses />,
    guarded: true,
    permission: screenRight.expenses,
  },
  {
    type: "",
    name: "",
    key: "expense-details",
    icon: (
      <Icon fontSize="small">
        <PriceChangeTwoToneIcon />
      </Icon>
    ),
    route: "/expenses/:id",
    component: <ExpenseDetails />,
    guarded: true,
    permission: screenRight.expenses,
  },

  //Debts
  {
    type: "option",
    name: "Debt Collection",
    user: "business",
    key: "",
    icon: (
      <Icon fontSize="small">
        <AccountBalanceIcon />
      </Icon>
    ),
    option: [
      {
        name: "Debts",
        route: "/debts",
        permission: screenRight.debts,
        key: "debts",
        icon: (
          <Icon fontSize="small">
            <CreditCardIcon />
          </Icon>
        ),
      },
      {
        name: "Invoice Reminder Logs",
        route: "/invoiceReminderLogs",
        permission: screenRight.invoiceReminderLogs,
        key: "invoiceReminderLogs",
        icon: (
          <Icon fontSize="small">
            <GroupIcon />
          </Icon>
        ),
      },
      // { name: 'Invoice Reminder Templates', route: '/invoiceReminderTemplate', permission: screenRight.invoiceReminderTemplates, key: "invoiceReminderTemplate", icon: <Icon fontSize="small"><SettingsIcon /></Icon> },
    ],
    guarded: true,
    permission: screenRight.debtCollection,
  },
  //Debts
  {
    type: "",
    name: "Debts",
    key: "debts",
    icon: (
      <Icon fontSize="small">
        <CreditCardIcon />
      </Icon>
    ),
    route: "/debts",
    user: "business",
    component: <Debts />,
    guarded: true,
    permission: screenRight.debts,
  },
  {
    type: "",
    name: "",
    key: "debts",
    icon: (
      <Icon fontSize="small">
        <ReceiptLongIcon />
      </Icon>
    ),
    route: "/debts/view/:id",
    component: <ViewDebts />,
    guarded: true,
    permission: screenRight.debts,
  },

  {
    type: "",
    name: "",
    key: "debt-recovery-action",
    route: "/debts/view/:id/:action",
    component: <Debts />,
    guarded: true,
    permission: screenRight.debts,
  },

  //Contacts added date 07Feb
  {
    type: "collapse",
    name: "Contacts",
    key: "contacts",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/contacts",
    component: <Contacts />,
    permission: screenRight.contacts,
  },

  {
    type: "",
    name: "",
    key: "contacts",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/contacts/addContact",
    component: <AddContact />,
    permission: screenRight.contacts,
  },
  {
    type: "",
    name: "",
    key: "contacts",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/contacts/editContact/:id",
    component: <AddContact />,
    permission: screenRight.contacts,
  },
  {
    type: "",
    name: "",
    key: "contacts",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/contacts/:id",
    component: <ContactDetails />,
    permission: screenRight.contacts,
  },
  {
    type: "",
    name: "",
    key: "contacts",
    icon: (
      <Icon fontSize="small">
        <ManageAccountsIcon />
      </Icon>
    ),
    route: "/contacts/view/:id",
    component: <ContactDetails />,
    permission: screenRight.contacts,
  },

  {
    type: "",
    name: "Invoice Reminder Logs",
    key: "invoiceReminderLogs",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <AssignmentIcon />
      </Icon>
    ),
    route: "/invoiceReminderLogs",
    component: <InvoiceReminderLogs />,
    guarded: true,
    permission: screenRight.invoiceReminderLogs,
  },
  {
    type: "",
    name: "Invoice Reminder Templates",
    key: "invoiceReminderTemplate",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <ViewQuiltIcon />
      </Icon>
    ),
    route: "/invoiceReminderTemplate",
    component: <InvoiceReminderTemplate />,
    guarded: true,
    permission: screenRight.invoiceReminderTemplates,
  },

  {
    type: "",
    name: "Add Invoice Reminder Template",
    key: "invoiceReminderTemplate",
    icon: <Icon fontSize="small">Add Template</Icon>,
    route: "/invoiceReminderTemplate/new",
    component: <AddInvoiceReminderTemplate />,
    guarded: true,
    permission: screenRight.invoiceReminderTemplates,
  },
  {
    type: "",
    name: "Edit Invoice Reminder Templates",
    key: "invoiceReminderTemplate",
    icon: <Icon fontSize="small">Edit Template</Icon>,
    route: "/invoiceReminderTemplate/edit/:id",
    component: <AddInvoiceReminderTemplate />,
    guarded: true,
    permission: screenRight.invoiceReminderTemplates,
  },
  {
    type: "option",
    name: "Settings",
    key: "mysettings",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <SettingsIcon />
      </Icon>
    ),

    option: [
      {
        name: "Users",
        route: "/myusers",
        permission: screenRight.myUsers,
        key: "myusers",
        icon: (
          <Icon fontSize="small">
            <GroupIcon />
          </Icon>
        ),
      },
      {
        name: "Items",
        route: "/items",
        permission: screenRight.items,
        key: "items",
        icon: (
          <Icon fontSize="small">
            <GridViewIcon />
          </Icon>
        ),
      },
      // { name: 'Accounts', route: '/itemCategory', permission: screenRight.categories, key: "itemCategory", icon: <Icon fontSize="small"><CategoryIcon /></Icon> },
      {
        name: "User Roles",
        route: "/myroles",
        permission: screenRight.buRoles,
        key: "myroles",
        icon: <Icon fontSize="small">verifiedUserIcon </Icon>,
      },
      {
        name: "Subscriptions",
        route: "/subscriptions",
        permission: screenRight.subscriptions,
        key: "subscriptions",
        icon: (
          <Icon fontSize="small">
            <ReceiptLongIcon />
          </Icon>
        ),
      },
      {
        name: "Default Settings",
        route: "/settings?tab=business",
        permission: screenRight.defaultSetting,
        key: "defaultSettings",
        icon: (
          <Icon fontSize="small">
            <SettingsIcon />
          </Icon>
        ),
      },
      {
        name: "Invoice Themes",
        route: "/invoicePdfFormat",
        permission: screenRight.invoices,
        key: "invoicePdfFormat",
        icon: (
          <Icon fontSize="small">
            <RoomPreferencesIcon />
          </Icon>
        ),
      },
      {
        name: "Invoice Reminder Templates",
        route: "/invoiceReminderTemplate",
        permission: screenRight.invoiceReminderTemplates,
        key: "invoiceReminderTemplate",
        icon: (
          <Icon fontSize="small">
            <SettingsIcon />
          </Icon>
        ),
      },
    ],
    guarded: true,
    permission: screenRight.mysettings,
  },
  //Business user Roles
  {
    type: "",
    name: "User Roles",
    key: "myroles",
    user: "business",
    icon: <Icon fontSize="small">verifiedUserIcon </Icon>,
    route: "/myroles",
    component: <SettingsPage />,
    guarded: true,
    permission: screenRight.buRoles,
  },
  {
    type: "",
    name: "Add Roles",
    key: "myroles",
    icon: <Icon fontSize="small">verifiedUserIcon </Icon>,
    route: "/myroles",
    component: <SettingsPage />,
    permission: screenRight.buRoles,
  },
  {
    type: "",
    name: "Add Roles",
    key: "myroles",
    icon: <Icon fontSize="small">EditRoles</Icon>,
    route: "/myroles/new",
    component: <SettingsPage />,
    permission: screenRight.buRoles,
  },
  {
    type: "",
    name: "Add Roles",
    key: "myroles",
    icon: <Icon fontSize="small">EditRoles</Icon>,
    route: "/myroles/edit/:id",
    component: <SettingsPage />,
    permission: screenRight.buRoles,
  },
  {
    type: "",
    name: "My Users",
    key: "myusers",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <GroupIcon />
      </Icon>
    ),
    route: "/myusers",
    component: <SettingsPage />,
    guarded: true,
    permission: screenRight.myUsers,
  },
  {
    type: "",
    name: "Add Users",
    key: "myusers",
    icon: <Icon fontSize="small">Add My users</Icon>,
    route: "/myusers/new",
    component: <SettingsPage />,
    guarded: true,
    permission: screenRight.myUsers,
  },
  {
    type: "",
    name: "Edit User",
    key: "myusers",
    icon: <Icon fontSize="small">Edit User</Icon>,
    route: "/myusers/edit/:id",
    component: <SettingsPage />,
    title: "Edit User",
    guarded: true,
    permission: screenRight.myUsers,
  },

  {
    type: "",
    name: "Default Settings",
    key: "defaultSettings",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <SettingsIcon />
      </Icon>
    ),
    route: "/defaultSettings",
    component: <SettingsPage />,
    guarded: true,
    permission: screenRight.defaultSetting,
  },

  {
    type: "collapse",
    name: " Accounts",
    key: "itemCategory",
    user: "admin",
    icon: (
      <Icon fontSize="small">
        <CategoryIcon />
      </Icon>
    ),
    route: "/itemCategory",
    component: <ItemCategory />,
    guarded: true,
    permission: screenRight.categories,
  },
  {
    type: "",
    name: "",
    key: "itemCategory",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/itemCategory/addItemCategory",
    component: <AddItemCategory />,
    guarded: true,
    permission: screenRight.categories,
  },
  {
    type: "",
    name: "Edit Category",
    key: "itemCategory",
    icon: <Icon fontSize="small">Edit User</Icon>,
    route: "/categories/edit/:id",
    component: <AddItemCategory />,
    title: "Edit Category",
    guarded: true,
    permission: screenRight.categories,
  },

  {
    type: "",
    name: "Items",
    key: "items",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <GridViewIcon />
      </Icon>
    ),
    route: "/items",
    component: <Items />,
    guarded: true,
    permission: screenRight.items,
  },
  {
    type: "",
    name: "",
    key: "",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/items/addItems",
    component: <Items initialAddDialog />,
    guarded: true,
    permission: screenRight.items,
  },
  {
    type: "",
    name: "",
    key: "",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/items/editItem/:id",
    component: <Items initialEditDialog />,
    guarded: true,
    permission: screenRight.items,
  },
  {
    type: "",
    name: "",
    key: "",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/items/editItem/itemid=:id",
    component: <Items initialEditDialog />,
    guarded: true,
    permission: screenRight.items,
  },
  //Business User Setting Menu
  {
    type: "option",
    name: "My Report",
    key: "myReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <AssessmentIcon />
      </Icon>
    ),
    option: [
      {
        name: "Item Reports",
        route: "/itemReport",
        permission: screenRight.itemReportBU,
        key: "itemReport",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <ImportContactsIcon />
          </Icon>
        ),
      },
      {
        name: "Contact Reports",
        route: "/contactReport",
        permission: screenRight.contactReportBU,
        key: "contactReport",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <ImportContactsIcon />
          </Icon>
        ),
      },
      {
        name: "Expense Reports",
        route: "/expensesReport",
        permission: screenRight.expensesReportBU,
        key: "expensesReport",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <RequestQuoteIcon />
          </Icon>
        ),
      },
      {
        name: "Invoice Reports",
        route: "/invoiceReport",
        permission: screenRight.invoiceReportBU,
        key: "invoiceReport",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <DescriptionIcon />
          </Icon>
        ),
      },
      {
        name: "RCTI Reports",
        route: "/rctiReport",
        permission: screenRight.rctiReportBU,
        key: "rctiReport",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <MenuBookIcon />
          </Icon>
        ),
      },
      {
        name: "Quotation Reports",
        route: "/quotationReport",
        permission: screenRight.quotationReportBU,
        key: "quotationReport",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <PendingActionsIcon />
          </Icon>
        ),
      },
      {
        name: "Aged Payables Summary",
        route: "/agedPayables",
        permission: screenRight.agedPayableSummaryBU,
        key: "agedPayables",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <PaymentsIcon />
          </Icon>
        ),
      },
      {
        name: "Aged Receivables Summary",
        route: "/agedReceivables",
        permission: screenRight.agedReceivablesSummaryBU,
        key: "agedReceivables",
        icon: (
          <Icon fontSize="small" style={{ marginTop: "5px" }}>
            <PriceCheckIcon />
          </Icon>
        ),
      },
    ],
    guarded: true,
    permission: screenRight.reportBU,
  },
  {
    type: "",
    name: "Contact Reports",
    key: "contactReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/contactReport",
    component: <ContactReport />,
    guarded: true,
    permission: screenRight.contactReport,
  },
  {
    type: "",
    name: "Item Reports",
    key: "itemReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/itemReport",
    component: <ItemsReport />,
    guarded: true,
    permission: screenRight.itemReport,
  },
  {
    type: "",
    name: "Expense Reports",
    key: "expensesReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/expensesReport",
    component: <ExpensesReport />,
    permission: screenRight.expensesReport,
  },

  {
    type: "",
    name: "Invoice Reports",
    key: "invoiceReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/invoiceReport",
    component: <InvoiceReport />,
    guarded: true,
    permission: screenRight.invoiceReport,
  },
  {
    type: "",
    name: "Invoice Reports",
    key: "invoiceReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/report/item/:id",
    component: <ReportForItem />,
    guarded: true,
    permission: screenRight.invoiceReport,
  },
  {
    type: "",
    name: "Quotation Reports",
    key: "quotationReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/quotationReport",
    component: <QuotationReport />,
    guarded: true,
    permission: screenRight.quotationReportBU,
  },
  {
    type: "",
    name: "RCTI Reports",
    key: "rctiReport",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/rctiReport",
    component: <RctiReport />,
    guarded: true,
    permission: screenRight.rctiReport,
  },
  {
    type: "",
    name: "Aged Receivables Summary",
    key: "agedReceivables",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/agedReceivables",
    component: <AgedReceivables />,
    guarded: true,
    permission: screenRight.agedReceivableSummaryBU,
  },
  {
    type: "",
    name: "Aged Payables Summary",
    key: "agedPayables",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <EngineeringIcon />
      </Icon>
    ),
    route: "/agedPayables",
    component: <AgedPayables />,
    guarded: true,
    permission: screenRight.agedPayableSummaryBU,
  },
  {
    type: "collapse",
    name: "Upload Legal Documents",
    key: "uploadLegalDocuments",
    user: "admin",
    icon: (
      <Icon fontSize="small">
        <ReceiptTwoToneIcon />
      </Icon>
    ),
    route: "/uploadLegalDocuments",
    component: <UploadLegalDocuments />,
    guarded: true,
    permission: screenRight.uploadLegalDocument,
  },
  {
    type: "",
    name: "Invoice Themes",
    key: "InvoicePdfFormat",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <RoomPreferencesIcon />
      </Icon>
    ),
    route: "/invoicePdfFormat",
    component: <InvoicePdfFormat />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "Add Invoice Themes",
    key: "InvoicePdfFormat",
    route: "/invoicePdfFormat/addInvoicePdfFormat",
    component: <AddInvoicePdfFormat />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "Edit Invoice Themes",
    key: "InvoicePdfFormat",
    route: "/invoicePdfFormat/editInvoicePdfFormat/:id",
    component: <AddInvoicePdfFormat />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "Invoice History",
    key: "InvoiceHistory",
    route: "/invoices/activityLog/:id",
    component: <InvoiceHistory />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "Quotation History",
    key: "QuotationHistory",
    route: "/quotations/activityLog/:id",
    component: <InvoiceHistory documentType="quotation" />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "",
    name: "ActivityLog",
    key: "ActivityLog",
    route: "/rcti/activityLog/:id",
    component: <InvoiceHistory documentType="rcti" />,
    guarded: true,
    permission: screenRight.invoices,
  },
  {
    type: "collapse",
    name: "Help",
    key: "help",
    user: "business",
    icon: (
      <Icon fontSize="small">
        <Receipt />
      </Icon>
    ),
    route: "/help",
    component: <HelpScreen />,

    permission: screenRight.help,
  },
];

export default routes;
